import { PRIVACY_POLICY_HTML } from "../assets/privacyContent.js";

export class settingsSubmenu {
    
    constructor(containerEl, uiManager) {
        this.container = containerEl;
        this.uiManager = uiManager;

        
        this.ui = {
            privacyBtn: this.container.querySelector("#open-privacy-btn"),

        }
    }

    init() {
        this.ui.privacyBtn.addEventListener("click", () => {
            this.uiManager.modalManager.open({
                id: "privacy-policy-modal",
                title: "Privacy Policy & Terms of Service",
                content: PRIVACY_POLICY_HTML,
                buttons: [
                    {
                    label: "Close",
                    class: "secondary-btn"
                    }
                ]
            });
        });
    }


}